
import React, { FC, useEffect } from 'react';
import { FontAwesomeIcon, FontAwesomeIcons } from 'src/constants/fontAwesomeIcons';
import useDispatch, { useActionCreator } from 'src/hooks/useDispatch';
import useSelector from 'src/hooks/useSelector';
import * as ThemeActions from '../../../actions/theme';

import './ThemeButton.scss';

const ThemeButton: FC = () => {

    const light = useSelector(state => state.theme.light);
    
    const dispatch = useDispatch();
    const setTheme = useActionCreator(ThemeActions.SetTheme, dispatch);

    const getCookie = (name: string) => {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return "";
    }

    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)");

    useEffect(() => {
        const themeCookie = getCookie("themeMode");
    
        if (themeCookie === "dark") {
            setTheme(false);
        } else if (themeCookie === "light") {
            setTheme(true);
        } else {
            setTheme(!systemTheme.matches ? true : false);
        }
    }, []);

    useEffect(() => {
        updateBodyClass(light);
    }, [
        light
    ]);

    const updateBodyClass = (light: boolean) => {
        if (light) {
            document.body.classList.remove("dark-theme");
            document.body.classList.add("light-theme");
            document.cookie = "themeMode=light; expires=Thu, 01 Jan 9999 00:00:00 UTC; path=/;";
        }
        else {
            document.body.classList.remove("light-theme");
            document.body.classList.add("dark-theme");
            document.cookie = "themeMode=dark; expires=Thu, 01 Jan 9999 00:00:00 UTC; path=/;";
        }
    };

    return (
        <button
            className="theme-button"
            onClick={() => {
                setTheme(!light);
            }}
            type="button"
        >
            {
                light ?
                    <FontAwesomeIcon 
                        className="theme-button-icon"
                        icon={FontAwesomeIcons.Duotone.SUN} 
                        fixedWidth
                    /> :
                    <FontAwesomeIcon 
                        className="theme-button-icon"
                        icon={FontAwesomeIcons.Duotone.MOON} 
                        fixedWidth
                    />
            }
        </button>
    );
}


export default ThemeButton;